import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { ReactNode } from 'react'
import { IntlShape } from 'react-intl'

import { ShowModalOptions } from './Modal'

export interface SummaryConsentParams {
  content: ReactNode
  intl: IntlShape
}

/**
 * @returns ShowModalOptions for common summary consent modal. Notice that buttons need to be in the children to be able to be handled in the caller.
 */
export const getSummaryConsentModalOptions = ({ content, intl }: SummaryConsentParams): ShowModalOptions => {
  const header = intl.formatMessage({ id: 'summary-consent-title' })

  return {
    children: content,
    contentAriaLabel: header,
    mode: ModalVisualMode.Plain,
  }
}
